<template>
  <ul class="news-list">
    <li
      v-for="(item, index) in list"
      :key="index"
      @click="cbDetail(item, index)"
      class="__flex __flex-vc __flex-cb"
    >
      <div class="time __flex __cor-8">
        <p class="year __fs-10">{{item.actualTime | formatTime('YYYY')}}</p>
        <p class="day __fs-16">{{item.actualTime | formatTime('MM-DD')}}</p>
      </div>
      <div class="news __flex __flex-cb">
        <p class="title __ta-left __fs-17 __ellipsis __line2">{{item.title}}</p>
        <p class="source __ta-left __line1 __cor-8 __fs-12">{{item.source}}</p>
      </div>
      <div  class="news-img __ta-right" v-if="item.listImg">
        <van-image
          class="news-icon __ta-right"
          :src="formatAliyunPath(item.listImg)"
        />
      </div>
    </li>
  </ul>
</template>

<script>
import { aliyun } from '@/agent'
export default {
  name: 'NewsList',
  props: {
    list: {
      type: Array
    }
  },
  data () {
    return {
    }
  },
  methods: {
    cbDetail (item) {
      this.$emit('cb-detail', item)
    },
    // 格式化阿里云地址
    formatAliyunPath (path) {
      return aliyun.getAliyunAddress(path)
    },
  }
}
</script>

<style lang="scss" scoped>
.news-list {
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
  li {
    margin-top: 26px;
    .time {
      height: 78px;
      flex-direction: column;
      justify-content: start;
      white-space: nowrap;
      .year {
        max-width: 197px;
        align-self: start;
        margin-bottom: 10px;
      }
      .day {
        max-width: 197px;
        align-self: start;
      }
    }
    .news {
      width: 100%;
      height: 78px;
      flex-direction: column;
      margin-left: 28px;
      .title {
        margin-top: -4px;
      }
      .source {
        word-break: break-all;
        max-width: 130px;
      }
    }
    .news-img {
      margin-left: 34px;
      .news-icon {
        width: 105px;
        height: 78px;
        flex-shrink: 0;
      }
    }
  }
}
</style>
